<template>
  <div class="contents">
    <div class="container-fluid">
      <div class="breadcrumb-main user-member justify-content-sm-between mb-3">
        <h4 class="text-capitalize fw-500 breadcrumb-title">Tarik Saldo Toko (Admin)</h4>
      </div>

      <ul class="nav nav-tabs mb-3">
        <li class="nav-item">
          <a class="nav-link" :class="{active: status === 'pending'}" @click="setStatus('pending')" style="cursor:pointer">
            Pending <span class="badge badge-warning ml-1">{{ pendingCount }}</span>
          </a>
        </li>
        <li class="nav-item"><a class="nav-link" :class="{active: status === 'completed'}" @click="setStatus('completed')" style="cursor:pointer">Selesai</a></li>
        <li class="nav-item"><a class="nav-link" :class="{active: status === 'rejected'}" @click="setStatus('rejected')" style="cursor:pointer">Ditolak</a></li>
        <li class="nav-item"><a class="nav-link" :class="{active: status === ''}" @click="setStatus('')" style="cursor:pointer">Semua</a></li>
      </ul>

      <div class="card p-3 border bg-white radius-xl">
        <div v-if="isLoading" class="text-center"><div class="spinner-border"></div></div>
        <div v-else-if="requests.length === 0" class="text-center text-muted p-4">
          Tidak ada permintaan tarik saldo dengan filter ini.
        </div>
        <div v-else class="table-responsive">
          <table class="table table-hover mb-0">
            <thead style="background:#f9fafb;">
              <tr>
                <th>Waktu</th>
                <th>Toko</th>
                <th>Pemilik</th>
                <th>Amount</th>
                <th>Fee</th>
                <th>Net Transfer</th>
                <th>Rekening</th>
                <th>Status</th>
                <th class="text-right">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in requests" :key="r.id">
                <td><small>{{ formatTime(r.created_at) }}</small></td>
                <td>
                  <div><b>{{ r.shop_name || '-' }}</b></div>
                  <small v-if="r.shop_slug" class="text-muted">/{{ r.shop_slug }}</small>
                </td>
                <td>
                  <div>{{ r.owner_name || ('User #' + r.user_id) }}</div>
                  <small class="text-muted d-block">{{ r.owner_email || '-' }}</small>
                  <small v-if="r.owner_phone" class="text-muted d-block">{{ r.owner_phone }}</small>
                </td>
                <td><b>{{ formatRupiah(r.amount) }}</b></td>
                <td class="text-danger">{{ formatRupiah(r.withdraw_fee) }}</td>
                <td><b class="text-success">{{ formatRupiah(netTransfer(r)) }}</b></td>
                <td>
                  <b>{{ r.bank_name }}</b><br>
                  <small>{{ r.bank_account_number }}<br>{{ r.bank_account_holder }}</small>
                </td>
                <td>
                  <span class="badge" :class="statusBadge(r.status)">{{ statusLabel(r.status) }}</span>
                  <small v-if="r.admin_notes" class="d-block text-muted">{{ r.admin_notes }}</small>
                  <small v-if="r.processed_at" class="d-block text-muted">{{ formatTime(r.processed_at) }}</small>
                </td>
                <td class="text-right">
                  <div v-if="r.status === 'pending'">
                    <button class="btn btn-sm btn-success" @click="openApprove(r)">
                      <i class="fas fa-check"></i> Setujui
                    </button>
                    <button class="btn btn-sm btn-danger ml-1" @click="openReject(r)">
                      <i class="fas fa-times"></i> Tolak
                    </button>
                  </div>
                  <a v-else-if="r.proof_image_url" :href="r.proof_image_url" target="_blank" class="btn btn-sm btn-light">
                    Lihat Bukti
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <modal name="approve_modal" :height="'auto'" :adaptive="true">
        <div class="p-4" v-if="selected">
          <h4>Setujui & Tandai Sudah Ditransfer</h4>
          <div class="alert alert-warning">
            <b>Pastikan sudah transfer manual</b> ke rekening:<br>
            <b>{{ selected.bank_name }}</b> {{ selected.bank_account_number }}<br>
            a/n: <b>{{ selected.bank_account_holder }}</b><br>
            Amount: <b>{{ formatRupiah(selected.amount) }}</b><br>
            Fee: <b>{{ formatRupiah(selected.withdraw_fee) }}</b><br>
            Net transfer: <b>{{ formatRupiah(netTransfer(selected)) }}</b>
          </div>
          <label>Bukti Transfer URL (opsional)</label>
          <input v-model="approveForm.proof_image_url" class="form-control mb-2" placeholder="https://...">
          <label>Catatan (opsional)</label>
          <textarea v-model="approveForm.admin_notes" class="form-control mb-3" rows="2"></textarea>
          <div class="text-right">
            <button type="button" class="btn btn-secondary" @click="$modal.hide('approve_modal')">Batal</button>
            <button class="btn btn-success ml-2" @click="approve" :disabled="processing">
              {{ processing ? 'Processing...' : 'Konfirmasi: Sudah Ditransfer' }}
            </button>
          </div>
        </div>
      </modal>

      <modal name="reject_modal" :height="'auto'" :adaptive="true">
        <div class="p-4" v-if="selected">
          <h4>Tolak Permintaan Tarik Saldo</h4>
          <p>Saldo akan dikembalikan ke akun pemilik toko. User akan dikirim notif WA.</p>
          <label>Alasan Penolakan *</label>
          <textarea v-model="rejectForm.admin_notes" class="form-control mb-3" rows="3" required></textarea>
          <div class="text-right">
            <button type="button" class="btn btn-secondary" @click="$modal.hide('reject_modal')">Batal</button>
            <button class="btn btn-danger ml-2" @click="reject" :disabled="processing || !rejectForm.admin_notes">
              {{ processing ? 'Processing...' : 'Tolak Withdrawal' }}
            </button>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      status: 'pending',
      requests: [],
      pendingCount: 0,
      isLoading: false,
      processing: false,
      selected: null,
      approveForm: { proof_image_url: '', admin_notes: '' },
      rejectForm: { admin_notes: '' },
    };
  },
  mounted() {
    this.loadAll();
  },
  methods: {
    setStatus(s) { this.status = s; this.loadAll(); },
    netTransfer(r) {
      if (r.net_transfer_amount > 0) return r.net_transfer_amount;
      return Math.max(0, (r.amount || 0) - (r.withdraw_fee || 0));
    },
    async loadAll() {
      this.isLoading = true;
      try {
        const r = await this.$store.dispatch('shop_balance/admin_withdrawals_list', { status: this.status, limit: 100 });
        this.requests = r.data.data.requests || [];
        const r2 = await this.$store.dispatch('shop_balance/admin_withdrawals_list', { status: 'pending', limit: 1 });
        this.pendingCount = r2.data.data.total || 0;
        if (this.status !== 'pending') {
          this.requests = r.data.data.requests || [];
        }
      } catch (e) {
        this.$toast.error('Gagal load data tarik saldo');
      }
      this.isLoading = false;
    },
    openApprove(r) {
      this.selected = r;
      this.approveForm = { proof_image_url: '', admin_notes: '' };
      this.$modal.show('approve_modal');
    },
    openReject(r) {
      this.selected = r;
      this.rejectForm = { admin_notes: '' };
      this.$modal.show('reject_modal');
    },
    async approve() {
      this.processing = true;
      try {
        const payload = {};
        if (this.approveForm.proof_image_url) payload.proof_image_url = this.approveForm.proof_image_url;
        if (this.approveForm.admin_notes) payload.admin_notes = this.approveForm.admin_notes;
        await this.$store.dispatch('shop_balance/admin_withdrawal_approve', { id: this.selected.id, payload });
        this.$toast.success('Disetujui & user dinotifikasi');
        this.$modal.hide('approve_modal');
        this.loadAll();
      } catch (e) {
        this.$toast.error(e.response?.data?.message || 'Gagal setujui');
      }
      this.processing = false;
    },
    async reject() {
      if (!this.rejectForm.admin_notes) {
        this.$toast.error('Alasan penolakan wajib diisi');
        return;
      }
      this.processing = true;
      try {
        await this.$store.dispatch('shop_balance/admin_withdrawal_reject', {
          id: this.selected.id,
          payload: this.rejectForm,
        });
        this.$toast.success('Ditolak & saldo user dikembalikan');
        this.$modal.hide('reject_modal');
        this.loadAll();
      } catch (e) {
        this.$toast.error(e.response?.data?.message || 'Gagal tolak');
      }
      this.processing = false;
    },
    formatRupiah(v) { return 'Rp ' + (v || 0).toLocaleString('id-ID'); },
    formatTime(t) { return t ? moment(parseInt(t)).format('DD MMM YYYY HH:mm') : '-'; },
    statusLabel(s) {
      return { pending: 'Pending', completed: 'Selesai', rejected: 'Ditolak', approved: 'Disetujui' }[s] || s;
    },
    statusBadge(s) {
      return {
        'badge-warning': s === 'pending',
        'badge-info': s === 'approved',
        'badge-success': s === 'completed',
        'badge-danger': s === 'rejected',
      };
    },
  },
};
</script>
